import {doGet} from './axiosActions.js'

export default {

    doGetUserCart({ commit }, payload){
        //simulated

    },

    doUpdatePaymentTerms({ commit }, payload) {
        
        var params = {
            action: 'cart/updateMonthlyInstallments',
            endpoint: 'api',
            data: {
                monthly_installments: payload
            }
        }

        doGet(params)
        .then(data => {
            return new Promise((resolve, reject) => {
                commit('setUser', JSON.parse(data.user_json_data))
                resolve(payload)
            })
        })
        .catch(error => {
            console.log('ajax error', error)
            return new Promise((resolve, reject) => {
                reject(error)
            })
        })
        .finally(() => {

        })
    },

    // Sets item to quanty 
    // To remove set to 0
    doUpdateCart({ commit }, payload) {
        var params = {
            action: payload.action,
            endpoint: 'api',
            data: {
                quantity: payload.item.quantity,
                sku_code: payload.item.sku_code
            }
        }

        doGet(params)
        .then(data => {
            return new Promise((resolve, reject) => {
                commit('setUser', JSON.parse(data.user_json_data))
                resolve(payload)
            })
        })
        .catch(error => {
            console.log('ajax error', error)
            return new Promise((resolve, reject) => {
                reject(error)
            })
        })
        .finally(() => {

        })
    },

    doAddToWishlist({ commit }, payload) {

        let data = payload.sku_code
        var params = {
            action: 'wishlist/add',
            endpoint: 'api',
            data: {
                sku_code: payload.sku_code,
            }
        }

        doGet(params)
        .then(data => {
            return new Promise((resolve, reject) => {
                commit('setAddToWishlist', payload)
                resolve(payload)
            })
        })
        .catch(error => {
            console.log('ajax error', error)
            return new Promise((resolve, reject) => {
                reject(error)
            })
        })
        .finally(() => {

        })

    },

    doRemoveFromWishlist({ commit }, payload) {

        let data = payload.sku
        var params = {
            endpoint: 'api',
            action: 'wishlist/remove',
            data: {
                sku_code: payload.sku,
            }
        }

        doGet(params)
        .then(data => {
            console.log('remove', data)
            commit('setRemoveFromWishlist', payload)
            resolve(payload)
        })
        .catch(error => {
            console.log('ajax error', error)
            reject(error)
        })
        .finally(() => {

        })

    },

}



// WEBPACK FOOTER //
// ./assets/js/vue/store/actions/usersActions.js